import { Routes, Route, useNavigate, useLocation } from "react-router-dom"
import { useState, useEffect } from "react"
import Navbar from "./components/NavbarComponent"
import Home from "./components/Home"
import PatientDetails from "./components/PatientDetails"
import Login from "./components/Login"
import Survey from "./components/Survey"
import Register from "./components/Register"
import ErrorBoundary from "./components/ErrorBoundary"
import { ADMIN_CREDENTIALS, DEFAULTS } from "./constants/app"
import { auth } from "./utils"

export default function App() {
  // Initialize state from localStorage using utility functions
  const [isLoggedIn, setIsLoggedIn] = useState(() => auth.isLoggedIn());
  const [userEmail, setUserEmail] = useState(() => auth.getUserEmail());
  const [isAdmin, setIsAdmin] = useState(() => auth.isAdmin());
  const [hospitalName, setHospitalName] = useState(() => auth.getHospitalName());
  const [userId, setUserId] = useState(() => auth.getUserId());
  
  const navigate = useNavigate();
  const location = useLocation();
  


  const handleLogin = (email: string, isAdminUser: boolean, hospitalNameParam?: string, userIdParam?: string) => {
    const displayName = hospitalNameParam || (isAdminUser ? ADMIN_CREDENTIALS.NAME : DEFAULTS.HOSPITAL_NAME);
    const userIdValue = userIdParam || '';
    
    // Update state
    setIsLoggedIn(true);
    setUserEmail(email);
    setIsAdmin(isAdminUser);
    setHospitalName(displayName);
    setUserId(userIdValue);
    
    // Save to localStorage using utility
    auth.saveUserSession(email, isAdminUser, displayName, userIdValue);
    navigate('/');
  };

  const handleLogout = () => {
    // Clear state
    setIsLoggedIn(false);
    setUserEmail('');
    setIsAdmin(false);
    setHospitalName('');
    setUserId('');
    
    // Clear localStorage using utility
    auth.clearUserSession();
    navigate('/');
  };

  // Prevent browser back navigation when logged out (except for /survey route)
  useEffect(() => {
    if (!isLoggedIn && location.pathname !== '/survey') {
      window.history.pushState(null, '', '/');
    }
  }, [isLoggedIn, location.pathname]);

  return (
    <ErrorBoundary>
      <div className="min-h-screen bg-gray-100">
        <Routes>
          <Route path="/survey" element={<Survey />} />
          <Route path="/register" element={<Register />} />
          <Route path="/" element={
            !isLoggedIn ? (
              <Login onLogin={handleLogin} />
            ) : (
                <div className="min-h-screen bg-gray-100">
                  <Navbar isLoggedIn={true} userName={hospitalName} onLogout={handleLogout} />
                  <Home userEmail={userEmail} isAdmin={isAdmin} userId={userId} />
                </div>
            )
          } />
          <Route path="/patient/:id" element={
            !isLoggedIn ? (
              <Login onLogin={handleLogin} />
            ) : (
              <div className="min-h-screen bg-gray-100">
                <Navbar isLoggedIn={true} userName={hospitalName} onLogout={handleLogout} />
                <PatientDetails />
              </div>
            )
          } />
          <Route path="*" element={<div>Route not found: {location.pathname}</div>} />
        </Routes>
      </div>
    </ErrorBoundary>
  )
}
